import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data';
import { Check, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Services = ({ showCta = true }) => {
  const service = services[0];

  return (
    <section id="behandling" className="pt-16 pb-24 md:pt-24 md:pb-32 bg-orange-50/40 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Image Side */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="w-full sm:w-4/5 sm:mx-auto md:w-1/2 lg:w-1/2"
          >
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={service.image}
                  alt="Integrativ Massageterapi detalje"
                  className="w-full h-full object-cover grayscale-[20%] hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
          </motion.div>

          {/* Content Side */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="w-full lg:w-1/2"
          >
            <div className="max-w-xl">
              <span className="text-xs uppercase tracking-[0.2em] text-stone-400 mb-4 block">
                Behandlingen
              </span>
              <h2 className="text-3xl md:text-4xl font-light text-stone-900 mb-6 leading-tight">
                {service.title}
              </h2>
              
              <div className="space-y-6 text-stone-600 font-light leading-relaxed">
                <p className="text-lg text-stone-800 font-normal whitespace-pre-line">
                  {showCta ? service.shortDescription : service.fullDescription}
                </p>
              </div>

              {showCta && (
                <div className="mt-8">
                  <Link 
                    to={`/behandling/${service.id}`}
                    className="inline-flex items-center justify-center px-10 py-4 bg-[#b8a58d] text-stone-50 rounded-none hover:bg-[#a6947e] transition-all duration-300 shadow-sm group tracking-widest text-xs uppercase"
                  >
                    <span>Læs mere om behandlingen</span>
                    <ArrowRight size={14} className="ml-2 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              )}

              <div className="mt-16">
                <h3 className="text-[10px] uppercase tracking-[0.3em] text-stone-400 font-bold mb-8">
                  Behandlingen kan hjælpe med:
                </h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-8">
                  {service.benefits.map((benefit, index) => (
                    <motion.li 
                      key={index} 
                      initial={{ opacity: 0, x: -10 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.05 * index }}
                      className="flex items-center space-x-4 group"
                    >
                      <div className="w-1.5 h-1.5 bg-stone-400 rounded-full group-hover:bg-stone-900 transition-colors"></div>
                      <span className="text-sm text-stone-700 tracking-wide">{benefit}</span>
                    </motion.li>
                  ))}
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;
